import { graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Navigation]);

function Gallery(props) {
  return (
    <StaticQuery
      query={graphql`
        query pictures {
          allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/(projects/*)/" } }
          ) {
            edges {
              node {
                frontmatter {
                  path
                  projectGallery {
                    publicURL
                    childImageSharp {
                      fluid(maxWidth: 1200) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                }
                html
              }
            }
          }
        }
      `}
      render={(data) => {
        const currentProject = data.allMarkdownRemark.edges.find(
          (n) => n.node.frontmatter.path === props.path
        );
        if (currentProject) {
          const galleryImages = currentProject.node.frontmatter.projectGallery;
          let classImageGallery = 'gallery__image';
          if (galleryImages && galleryImages.length === 1) {
            classImageGallery += ' gallery__image--alone';
          }
          if (galleryImages && galleryImages.length) {
            const paramsSwiperMobile = {
              loop: true,
              spaceBetween: 50,
              slidesPerView: 1,
              navigation: {
                prevEl: '.navigation-left',
                nextEl: '.navigation-right',
              },
            };
            const paramsSwiperDesktop = {
              loop: true,
              spaceBetween: 50,
              slidesPerView: 1,
              speed: 0,
              navigation: {
                prevEl: '.navigation-left',
                nextEl: '.navigation-right',
              },
            };
            return (
              <div>
                <div className="d-none d-md-block swiper-container-custom">
                  <div className="navigation">
                    <div className="navigation-left"></div>
                    <div className="navigation-right"></div>
                  </div>
                  <Swiper {...paramsSwiperDesktop}>
                    {galleryImages.map((imageInGallery, key) => {
                      return (
                        <SwiperSlide key={key}>
                          <Img
                            className={classImageGallery}
                            fluid={imageInGallery.childImageSharp.fluid}
                            imgStyle={{ objectFit: 'contain' }}
                          />
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
                <div className="d-block d-md-none swiper-container-custom">
                  <Swiper {...paramsSwiperMobile}>
                    {galleryImages.map((imageInGallery, key) => {
                      return (
                        <SwiperSlide key={key}>
                          <Img
                            className={classImageGallery}
                            fluid={imageInGallery.childImageSharp.fluid}
                            imgStyle={{ objectFit: 'contain' }}
                          />
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              </div>
            );
          }
        }
        return <div className="gallery"></div>;
      }}
    />
  );
}

export default Gallery;
